// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1_t8s","boxTitle":"Qualiphy_boxTitle__1dHo6","box":"Qualiphy_box__30nE3","toggleWrap":"Qualiphy_toggleWrap__1cb9m"};